export const isValidEmail = (value) => {
    let re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(value);
};
export const lengthMoreThan = (value, length) => value.length > length;

export const isValidSSN = (value) => {
    let re = /^\d{10}$/;
    return re.test(value);
};

export const isValidPhone = (value) => {
    let re = /^(([+374]{4}|[0]{1}))?([1-9]{2})(\d{6})$/;
    return re.test(value);
};
